// for albums, locations, photos
import {
    SET_LOADING,
    SET_ERROR,
    CLEAR_ERROR,
} from '../mutation-types';
import axios from 'axios';

export default {
    /**
     * States
     */
    state: {
        postsCategory: null,
        posts: null,
        post: null,
        postsCategories: null,
        postsLinks: null,
        endpoint: '',
        title: '',
    },

    /**
     * Mutations
     */
    mutations: {
        setPostsCategory(state, payload) {
            state.postsCategory = payload;
        },

        setPost(state, payload) {
            state.post = payload;
        },

         setPosts(state, payload) {
            state.posts = payload;
        },

        setPostsCategories(state, payload) {
            state.postsCategories = payload;
        },

        setPostsLinks(state, payload) {
            state.postsLinks = payload;
        },

    },

    /**
     * Getters
     */
    getters: {
        post: state => state.post,
        posts: state => state.posts,
        postsCategories: state => state.postsCategories,
        postsCategory: state => state.postsCategory,
        postsLinks: state => state.postsLinks,
        // title (state) {
        //     return state.title;
        // },

    },

    /**
     * Actions
     */
    actions: {

        fetchPosts({ commit, getters }, payload) {
            console.log('fetch posts time: ', Date.now(), payload);
            commit(SET_LOADING, true);
            commit(CLEAR_ERROR);

            axios.get(payload)
                .then((response) => {
                    commit(SET_LOADING, false);
                    // console.log('RESPONSE posts: ' , response.data);

                    if(response.data !== undefined) {
                        if(response.data.hasOwnProperty('category')) {
                            commit('setPostsCategory', response.data.category);
                        }
                        commit('setPosts', response.data.posts);
                        commit('setPostsCategories', response.data.categories);

                        commit('setTitle', response.data.posts.name);

                        // set meta description, meta keywords
                        if(typeof response.data.metas === undefined) {
                            console.log( 'type of metas undefined: ', response.data);
                        }
                        if(typeof response.data.metas === 'undefined') {
                            console.log( 'type of metas undefined: ', response.data);
                        }
                        if(response.data.hasOwnProperty('metas')) {
                            console.log( 'metas property ok: ', response.data);
                        }

                        if(response.data.hasOwnProperty('metas') && response.data.metas === '') {
                            console.log( 'metas property ok but empty: ');
                        }

                        document.head.querySelector('meta[name=description]').content = response.data.metas.meta_description;
                        document.head.querySelector('meta[name=keywords]').content = response.data.metas.meta_keywords;
                        document.title = response.data.metas.meta_title;
                    }

                })
                .catch((error) => {
                    // console.log('STORE error fetching location: ',error.response);
                    commit(SET_LOADING, false);
                    // commit(SET_ERROR, error.response.data.errors.error);
                });
        },

        fetchPost({ commit, getters }, payload) {
            // post/12
            // console.log('time: ', Date.now(), payload);
            commit(SET_LOADING, true);
            commit(CLEAR_ERROR);

            axios.get(payload)
                .then((response) => {
                    commit(SET_LOADING, false);
                    // console.log('RESPONSE posts: ' , response.data.posts);

                    if(response.data !== undefined) {
                        let data = response.data;
                        // commit('setItems', data);
                        commit('setPost', data.post);
                        commit('setPostsCategories', data.categories);
                        commit('setTitle', data.post.title);
                        commit('setPostsLinks', response.data.links);

                        // set meta description, meta keywords
                        document.head.querySelector('meta[name=description]').content = data.metas.meta_description;
                        document.head.querySelector('meta[name=keywords]').content = data.metas.meta_keywords;
                        document.title = data.metas.meta_title;
                        // console.log(this.getters, response.data.post);
                    }

                })
                .catch((error) => {
                    console.log('STORE error fetching location: ',error.response);
                    commit(SET_LOADING, false);
                    // commit(SET_ERROR, error.response.data.errors.error);
                });
        },

    }

};



// WEBPACK FOOTER //
// ./src/store/modules/posts.js